import React, {PropTypes} from 'react';
import {FormattedNumber} from 'react-intl';

import * as resources from 'constants/accountResourceNames';

export default class Balance extends React.Component {
    static propTypes = {
        balance: PropTypes.any.isRequired,
        resourceId: PropTypes.number.isRequired,
        refreshAction: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onRefreshClick = this._onRefreshClick.bind(this);
    }

    _onRefreshClick(e) {
        e.preventDefault();

        this.props.refreshAction();
    }

    render() {
        const {balance, resourceId} = this.props;
        const currency = resources.resourceNames[resourceId];

        return (
                <li className='balance'>
                    <a href='#' onClick={this._onRefreshClick}>
                        {currency}
                        &nbsp;
                        <FormattedNumber value={balance} maximumFractionDigits={2} />
                    </a>
                </li>
        );
    }
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/header/Balance.jsx